import React, { useEffect } from 'react'
import { Dimensions, Image, StyleSheet, View } from 'react-native'
import { useNavigation } from '@react-navigation/core'
import { useSelector } from 'react-redux'

import { CustomText } from '../../components/text/StyledText'
import { ButtonPrimary } from '../../components/buttons/StyledButtons'
import { sproglandHeaderBackImage, sproglandHeaderStyle, sproglandJuniorHeaderTitle } from './SproglandOptions'
import Colors from '../../constants/Colors'
import { LanguagePicker } from '../../components/formElements/LanguagePicker'
import MainContainer from '../../components/MainContainer/MainContainer'
import NormalIcon from '../../components/icons/NormalIcon'
import { txt } from '../../locales/i18n'

const { width } = Dimensions.get('window')
const small = width < 800
const banner = 'https://filer.boblberg.dk/Assets/Img/sprogland/sprogland-junior-banner.png'

export default function JuniorIntroScreen() {
	const navigation = useNavigation()
	const userToken = useSelector((state) => state.userToken)

	useEffect(() => {
		navigation.setOptions({
			headerBackTitle: small && ' ',
			headerBackTitleStyle: { color: Colors.text, fontFamily: 'raleway-regular' },
			headerBackImage: () => sproglandHeaderBackImage(navigation),
			headerTitle: () => sproglandJuniorHeaderTitle(true),
			headerStyle: { ...sproglandHeaderStyle, backgroundColor: Colors.white },
		})
	}, [])

	const handleGetStarted = () => {
		if (userToken) return navigation.navigate('SproglandJunior')
		navigation.navigate('LearnDanishSignup', { originScreen: 'SproglandJunior' })
	}

	return (
		<MainContainer backgroundColor={Colors.redCrossBackground}>
			<View style={styles.container}>
				<Image
					style={[styles.bannerImage, !small && { height: 150 }]}
					resizeMode={'contain'}
					accessibilityIgnoresInvertColors
					source={{ uri: banner }}
					accessible
					accessibilityRole="image"
				/>

				<View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 16, marginTop: 24 }}>
					<CustomText font="gotham-bold-large">{'Language:'}</CustomText>
					<LanguagePicker onChangeStartScreen={'Sprogland'} />
				</View>

				<CustomText font="gotham-bold" style={{ marginBottom: 32, fontSize: 24 }}>
					{txt('learnDanish.junior.intro.title')}
				</CustomText>
				<CustomText font="gotham" style={{ marginBottom: 32 }}>
					{txt('learnDanish.junior.intro.body')}
				</CustomText>

				<CustomText font="gotham-bold" style={{ marginBottom: 12 }}>
					{txt('learnDanish.junior.intro.pointsHeader')}
				</CustomText>

				<View style={styles.point}>
					<NormalIcon name="check" size={12} stroke="fas" color={Colors.white} style={styles.icon} />
					<CustomText font="gotham" style={{ flex: 1 }}>{txt('learnDanish.junior.intro.point1')}</CustomText>
				</View>
				<View style={styles.point}>
					<NormalIcon name="check" size={12} stroke="fas" color={Colors.white} style={styles.icon} />
					<CustomText font="gotham" style={{ flex: 1 }}>{txt('learnDanish.junior.intro.point2')}</CustomText>
				</View>
				<View style={styles.point}>
					<NormalIcon name="check" size={12} stroke="fas" color={Colors.white} style={styles.icon} />
					<CustomText font="gotham" style={{ flex: 1 }}>{txt('learnDanish.junior.intro.point3')}</CustomText>
				</View>
				<View style={styles.point}>
					<NormalIcon name="check" size={12} stroke="fas" color={Colors.white} style={styles.icon} />
					<CustomText font="gotham" style={{ flex: 1 }}>{txt('learnDanish.junior.intro.point4')}</CustomText>
				</View>

				<ButtonPrimary
					title={txt('learnDanish.junior.intro.button')}
					onPress={() => handleGetStarted()}
					style={styles.button}
					titleStyle={{ fontSize: 20, fontFamily: 'gotham-book' }}
				/>
			</View>
		</MainContainer>
	)
}

const styles = StyleSheet.create({
	container: {
		width: '100%',
		maxWidth: 800,
		alignSelf: 'center',
		marginBottom: 50,
		paddingHorizontal: 20,
	},

	bannerImage: {
		alignSelf: 'center',
		width: width,
		height: 125,
		marginVertical: 24,
	},

	point: {
		flexDirection: 'row',
		alignItems: 'center',
		marginBottom: 8,
	},

	icon: {
		backgroundColor: Colors.greenIcon,
		borderRadius: 4,
		padding: 5,
		marginRight: 10,
	},

	button: {
		marginTop: 50,
		paddingHorizontal: 70,
		paddingVertical: 18,
		backgroundColor: Colors.redCross.red
	}
})
